import { Link } from "react-router-dom";
import Seo from "@/components/site/Seo";
import { Img } from "@/assets";
import StaticWorldMap from "@/components/site/StaticWorldMap";

export default function Strategic() {
  return (
    <>
      <Seo />
      <section className="gp-page-hero" data-testid="strategic-hero">
        <div className="gp-page-hero__img" aria-hidden="true"><Img id="oil-tanker-sea" alt="" /></div>
        <div className="gp-wrap gp-page-hero__inner">
          <div className="gp-eyebrow"><span className="gp-eyebrow-num">03</span><span className="gp-eyebrow-sep" /> Strategic Relationships</div>
          <h1 className="gp-h1 gp-page-hero__title">A network of partners across the trade.</h1>
          <p className="gp-page-hero__lede">
            Gold Petroleum's activities are supported by partner relationships in shipping, storage
            and refining. These give us reach across the markets we serve and a shared standard of
            execution with the counterparties we work alongside.
          </p>
        </div>
      </section>

      <section className="gp-section gp-on-white" data-testid="strategic-hint">
        <div className="gp-wrap">
          <div className="gp-eyebrow" style={{ color: "var(--gp-ink)" }}>
            <span className="gp-eyebrow-num">·</span><span className="gp-eyebrow-sep" /> How to read this page
          </div>
          <ul className="gp-hint-list" data-testid="strategic-hint-list">
            <li>Gold Petroleum FZ LLC is UAE-registered. Leadership may operate across UAE and Canada; registration and leadership location are distinct.</li>
            <li>Regions of ambition (Middle East, Africa, Asia) reflect where the company aims to build business. Confirmed operating countries will be added as they are approved.</li>
            <li>Partner relationships in shipping, storage and refining are documented, not company-owned. Company values guide communication; they are not a substitute for independent performance evidence.</li>
          </ul>
        </div>
      </section>

      <section className="gp-section gp-on-white" data-testid="strategic-body">
        <div className="gp-wrap">
          <div className="gp-eyebrow" style={{ color: "var(--gp-ink)" }}>
            <span className="gp-eyebrow-num">01</span><span className="gp-eyebrow-sep" /> Partner network
          </div>
          <h2 className="gp-h2" style={{ maxWidth: "20ch", marginBottom: 48 }}>
            Shipping, storage and refining.
          </h2>
          <div className="gp-panels" style={{ gridTemplateColumns: "1fr", gap: 24 }}>
            <div className="gp-tiles" style={{ gridTemplateColumns: "1fr", gap: 24 }}>
              <div className="gp-strip">
                <div>
                  <div className="gp-preview__num">01 / Shipping</div>
                  <h3 className="gp-h3" style={{ marginTop: 8 }}>Greece-based fleet operator</h3>
                  <p className="gp-body" style={{ marginTop: 12 }}>A Greece-based shipping company operating tankers and dry-cargo vessels, supporting movements across our target markets.</p>
                </div>
                <div className="gp-strip__media"><Img id="oil-tanker-sea" /></div>
              </div>
              <div className="gp-strip">
                <div>
                  <div className="gp-preview__num">02 / Storage</div>
                  <h3 className="gp-h3" style={{ marginTop: 8 }}>Sharjah &amp; Fujairah terminals</h3>
                  <p className="gp-body" style={{ marginTop: 12 }}>Terminal and storage-tank owners in Sharjah and Fujairah, UAE, providing strategic staging for regional flows.</p>
                </div>
                <div className="gp-strip__media"><Img id="storage-tanks-coastal" /></div>
              </div>
              <div className="gp-strip">
                <div>
                  <div className="gp-preview__num">03 / Refining</div>
                  <h3 className="gp-h3" style={{ marginTop: 8 }}>International refineries</h3>
                  <p className="gp-body" style={{ marginTop: 12 }}>Oil refineries in international markets, supporting supply and offtake across our petroleum activities.</p>
                </div>
                <div className="gp-strip__media"><Img id="refinery-pipes-close" /></div>
              </div>
            </div>
          </div>
          <div className="gp-callout" data-testid="strategic-clarification">
            <p>These are partner relationships. Vessels, terminals and refineries are not owned by Gold Petroleum FZ LLC.</p>
          </div>
        </div>
      </section>

      <section className="gp-section gp-on-navy" data-testid="strategic-regions">
        <div className="gp-wrap">
          <div className="gp-strip">
            <div>
              <div className="gp-eyebrow"><span className="gp-eyebrow-num">02</span><span className="gp-eyebrow-sep" /> Regional focus</div>
              <h2 className="gp-h2" style={{ color: "var(--gp-white)", maxWidth: "20ch" }}>Middle East. Africa. Asia.</h2>
              <p className="gp-body" style={{ marginTop: 20, color: "rgba(255,255,255,0.72)", maxWidth: "44ch" }}>
                Three regions, one operating standard — trading, terminal access and partner
                logistics anchored around the UAE with growing demand corridors east and south.
              </p>
              <div style={{ marginTop: 32, display: "flex", gap: 16, flexWrap: "wrap" }}>
                <Link to="/contact" className="gp-btn" data-testid="strategic-cta-contact">Discuss a partnership <span className="gp-arrow">→</span></Link>
                <Link to="/divisions" className="gp-link" data-testid="strategic-cta-divisions">See our divisions <span className="gp-arrow">→</span></Link>
              </div>
            </div>
            <div>
              <StaticWorldMap compact={true} caption={true} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
